<div modalHeader class="modal-header">
  <h2 class="my-2">Invite user</h2>
  <tr-icon [icon]="icon.cancel" classes="close-btn pt-1" (click)="close()"></tr-icon>
</div>

<div modalContent class="modal-body pb-0">
  <p>Invite a new user by entering their name, email, and role.</p>
  <form [formGroup]="form">
    <div class="row">
      <div class="col form-group">
        <label for="user-name" class="control-label">User Email*</label>
        <input
          id="user-name"
          type="text"
          class="form-control"
          formControlName="email"
          placeholder="Enter user email"
        />
        <control-messages [control]="emailControl"></control-messages>
      </div>

      <div class="col form-group">
        <label for="user-email" class="control-label">User Full Name*</label>
        <input
          id="user-email"
          type="text"
          class="form-control"
          formControlName="name"
          placeholder="Enter user full name"
        />
        <control-messages [control]="fullNameControl"></control-messages>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label">Role</label>
      <span class="bi bi-info-circle-fill info-badge ml-1" data-toggle="tooltip" data-placement="top" title="Users have no access to settings. Managers can access location preferences. Admins have full acccount privileges."></span>
      <tablesready-btn-group-control
        [items]="roles"
        bindName="name"
        bindValue="value"
        [control]="roleControl"
        [buttonType]="buttonColors.success"
      ></tablesready-btn-group-control>
    </div>

    <div class="form-group locations-list" *ngIf="!isAdminRoleSelected; else adminRoleSelected">
      <tablesready-checkbox-group
        [selectAll]="true"
        selectAllTitle="All locations"
        formControlName="locations"
        searchTitle="Location"
        searchPlaceholder="Search locations"
        [items]="locationsGroup"
      ></tablesready-checkbox-group>
    </div>
    <div *ngIf="!locationsControlValid">
      <p class="text-danger">Please, select at least 1 location</p>
    </div>
  </form>
</div>

<div modalFooter class="row p-3 pb-0 mb-0">
  <div class="form-group mb-0 col">
    <button
      ngbAutofocus
      class="btn btn-info mb-0 w-100"
      (click)="submit()"
    >
      Send invite
    </button>
  </div>

  <div class="form-group mb-0 col">
    <button class="btn btn-danger mb-0 w-100" [disabled]="inProgress" (click)="close()">Cancel</button>
  </div>
</div>

<ng-template #adminRoleSelected>
  <div class="d-flex flex-row justify-content-center">
    <p>You're about invite user as <b>admin</b>.</p>
  </div>
</ng-template>
